import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import DashboardLayout from '../../../layouts/DashboardLayout';
import WikiTabs from './WikiTabs';
import JurisdictionTabs from './JurisdictionTabs';
import AddJurisdictionPopup from '../AddJurisdictionPopup/AddJurisdictionPopup';
import { RootState } from '../../../redux/root';
import AddJurisdiction from '../SharedComponents/AddJurisdiction';
import JurisdictionTable from '../SharedComponents/JurisdictionTable';
import WikiGlossary from '../WikiGlossary/WikiGlossary';
import Keys from '../Keys/Keys';
import PropertyAppraiserLookup from '../PropertyAppraiserLookup/PropertyAppraiserLookup';

const WikiMain = () => {
  const wikiMode = useSelector((s: RootState) => s.wikiSlice.wikiMode);
  return (
    <DashboardLayout>
      <AddJurisdictionPopup />
      <TopWrapper>
        <Wrapper>
          <WikiTabs />
          <JurisdictionTabs />
          {wikiMode === 'JURI' && <>
            <AddJurisdiction />
            <JurisdictionTable />
          </>}
          {wikiMode === 'GLOSSARY' && <WikiGlossary />}
          {wikiMode === 'KEYS' && <Keys />}
        </Wrapper>
      </TopWrapper>
    </DashboardLayout>
  );
};

export default WikiMain;

const TopWrapper = styled.div`
 display: flex;
 flex-direction: column;
 height: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  padding: 0 20px;
  box-sizing: border-box;

  @media (max-width: 840px) {
    padding: 0 12px;
  }

  @media (max-width: 540px) {
    padding: 0 10px;
  }
`;
